import { createAction } from 'redux-actions'

const Actions = {
  SHOW_LOCATION: 'SHOW_LOCATION',
  HIDE_LOCATION: 'HIDE_LOCATION',
  SHOW_ALL_LOCATIONS: 'SHOW_ALL_LOCATIONS',
  HIDE_ALL_LOCATIONS: 'HIDE_ALL_LOCATIONS',
  RECEIVE_LOCATIONS: 'RECEIVE_LOCATIONS'
}

export default Actions

export const LOCATIONS_CHANGED = [
  Actions.SHOW_LOCATION,
  Actions.HIDE_LOCATION,
  Actions.SHOW_ALL_LOCATIONS,
  Actions.HIDE_ALL_LOCATIONS
]

export const showLocation = createAction(Actions.SHOW_LOCATION)
export const hideLocation = createAction(Actions.HIDE_LOCATION)
export const showAllLocations = createAction(Actions.SHOW_ALL_LOCATIONS)
export const hideAllLocations = createAction(Actions.HIDE_ALL_LOCATIONS)
export const receiveLocations = createAction(Actions.RECEIVE_LOCATIONS)
